export default __webpack_public_path__ + "static/media/chat_bot_image4.90993442.jpg";